import AppSwitch from "@toothfairy/shared-ui/AppSwitch";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import React from "react";

const ToothFairySwitch = ({
  wrapperStyle,
  labelColor = "darkGrey",
  ...props
}) => {
  const { currentTheme } = AppTheme.useTheme();
  return (
    <AppSwitch
      wrapperStyle={[
        {
          maxHeight: 30,
          paddingHorizontal: 0,
          borderRadius: 10,
          paddingVertical: 0,
        },
        wrapperStyle,
      ]}
      labelTextStyle={{
        fontSize: currentTheme?.theme?.small_font_size,
        color: props.disabled
          ? currentTheme?.theme?.mediumGrey
          : currentTheme?.theme[labelColor],
      }}
      showTextInputLabel={true}
      {...props}
      displayIsTicked={true}
    />
  );
};

export default ToothFairySwitch;
